
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/Home';
import Tribute from './pages/Tribute';
import Burial from './pages/Burial';
import SingleTribute from './pages/SingleTribute';
import SinglePersonFromTree from './pages/SinglePersonFromTree';
import FamilyTree from './pages/FamilyTree';
import FamilyTree2 from './pages/FamilyTree2';
import AddTribute from './pages/AddTribute';
import ConnectFamilyTree from './pages/ConnectFamilyTree';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import '@mantine/core/styles.css';
import '@mantine/dropzone/styles.css';
import Gallery from './pages/Gallery';
import TributeActions from './pages/TributeActions';
import SecurityForm from './pages/SecurityForm';



function App() {
  return <>
  <MantineProvider>
    <ModalsProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout/>}>
            <Route index element={<Home/>}/>
            <Route path='family-tree' element={<FamilyTree2/>}/>
            <Route path='gallery' element={<Gallery/>}/>
            <Route path='family-tree/connect' element={<ConnectFamilyTree/>}/>
            <Route path='family-tree2' element={<FamilyTree/>}/>
            <Route path='tributes' element={<Tribute/>}/>
            <Route path='tributes/add' element={<AddTribute/>}/>
            <Route path='tributes/Chief Engr. (Dr.) Donald Ike Igwegbu (Odera)' element={<SingleTribute/>}/>
            <Route path='family-tree/:name' element={<SinglePersonFromTree/>}/>
            <Route path='burial-arrangements' element={<Burial/>}/>
          </Route>
        </Routes>
      </Router>
    </ModalsProvider>
  </MantineProvider>

  </>
  
}

export default App;
